import { publicApiClient } from '@/lib/api/client';
import type { 
  EventScheduleResponse, 
  TableAvailabilityResponse,
  EventSchedule,
  TableAvailability 
} from '@/features/booking/types/tableBookingTypes';

export const tableBookingService = {
  /**
   * Get all event schedules for a specific event
   */
  getEventSchedules: async (eventId: string): Promise<EventSchedule[]> => {
    try {
      const response = await publicApiClient.get<EventScheduleResponse>(
        `/api/public/v1/event-schedule/event/${eventId}/all`
      );
      return response.data.map(item => item['event-schedule']);
    } catch (error) {
      console.error('Error fetching event schedules:', error);
      throw new Error('Failed to fetch event schedules');
    }
  },

  /**
   * Get table availability for a specific event schedule
   */
  getTableAvailability: async (eventScheduleId: string): Promise<TableAvailability> => {
    try {
      const response = await publicApiClient.get<TableAvailabilityResponse>(
        `/api/booking/v1/availability/table/event-schedule/${eventScheduleId}/all`
      );
      return response.data;
    } catch (error) {
      console.error('Error fetching table availability:', error);
      throw new Error('Failed to fetch table availability');
    }
  },

  /**
   * Create a table booking
   */
  createTableBooking: async (bookingData: {
    eventScheduleId: string;
    tableNumber: string;
    startTime: string;
    eventBookingCategoryId: string;
  }) => {
    try {
      // TODO: I will add the actual booking creation API call here
      console.log('Creating table booking:', bookingData);
      return { success: true, bookingId: 'mock-booking-id' };
    } catch (error) {
      console.error('Error creating table booking:', error);
      throw new Error('Failed to create table booking');
    }
  },

  /**
   * Get booking details by ID
   */
  getBookingDetails: async (bookingId: string) => {
    try {
      // TODO: I will add the actual booking details API call here
      console.log('Fetching booking details for:', bookingId);
      return { id: bookingId, status: 'confirmed' };
    } catch (error) {
      console.error('Error fetching booking details:', error);
      throw new Error('Failed to fetch booking details');
    }
  }
};

